import type {
  CreateDownloadResponse,
  DownloadFiltersType,
  DownloadStatusResponse,
} from '~/types/api';
import httpRequest from '~/utils/httpRequest';

export const createDownloadRequest = async (
  filters: DownloadFiltersType,
): Promise<CreateDownloadResponse> => {
  const res = await httpRequest.get<CreateDownloadResponse>(
    '/api/initiateCsvExport',
    {
      params: filters,
    },
  );
  return res.data;
};

export const checkDownloadStatus = async (
  requestId: string,
): Promise<DownloadStatusResponse> => {
  const res = await httpRequest.get<DownloadStatusResponse>(
    '/api/downloadStatus',
    {
      params: { requestId },
    },
  );
  return res.data;
};

export const abortCsvExport = async (
  requestId: string,
): Promise<{ success: boolean; message: string }> => {
  const res = await httpRequest.delete<{ success: boolean; message: string }>(
    '/api/abortCsvExport',
    {
      params: { requestId },
    },
  );
  return res.data;
};
